export default [
  {
    key: 'branchOfficeName',
    label: '支店名',
    style: {
    }
  }, 
  {
    key: 'departmentName',
    label: '部署名',
    style: {
    }
  },
  {
    key: 'userName',
    label: '社員名',
    style: {
    }
  },
  {
    key: 'overDate',
    label: '残業日時',
    style: {
    }
  },
  {
    key: 'comment',
    label: '残業理由',
    style: {
    }
  },
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/overTime/listHeader.js